import getLQCookieName from '@olx/react-laquesis/experiments/getCookieName';
import getLQFeatureFlagCookieName from '@olx/react-laquesis/featureFlags/getFeatureFlagCookieName';
import { cookie } from './index';

// eslint-disable-next-line import/prefer-default-export
export function getLQExperimentsAndFeatureFlags(): {
  lqCookie: string;
  lqFeatureFlagCookie: string;
  } {
  // experiments cookie "laquesis"
  const lqCookieKey = getLQCookieName();
  // feature flag cookie laquesisff
  const lqFeatureFlagCookieKey = getLQFeatureFlagCookieName();

  const lqCookie = cookie.get(lqCookieKey);
  const lqFeatureFlagCookie = cookie.get(lqFeatureFlagCookieKey);

  return { lqCookie, lqFeatureFlagCookie };
}
